export default (value = '', total = 2, pad = '0') => {
  while ((value.toString().length < total)) {
    value = pad + value.toString()
  }

  return value.toString()
}



// WEBPACK FOOTER //
// ./src/filters/strPad.js